module.exports = __webpack_public_path__ + "static/media/29ADMSPC25.659d0804.jpg";